import { render, staticRenderFns } from "./Backup.vue?vue&type=template&id=00455c9c&scoped=true"
import script from "./Backup.vue?vue&type=script&lang=ts"
export * from "./Backup.vue?vue&type=script&lang=ts"
import style0 from "./Backup.vue?vue&type=style&index=0&id=00455c9c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00455c9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00455c9c')) {
      api.createRecord('00455c9c', component.options)
    } else {
      api.reload('00455c9c', component.options)
    }
    module.hot.accept("./Backup.vue?vue&type=template&id=00455c9c&scoped=true", function () {
      api.rerender('00455c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/Backup.vue"
export default component.exports